import { anyOf, arrayOf, is, maybe, objectOf } from "@altostra/type-validations";
import { any, number, string } from "@altostra/type-validations/lib/primitives";

const isPreviewAndValidatePreviewHeader = objectOf({
  name: string,
  data_type: maybe(string),
});

const isPreviewAndValidatePreview = objectOf({
  headers: arrayOf(isPreviewAndValidatePreviewHeader),
  rows: arrayOf(arrayOf(any)),
  length: number,
});

const isPreviewAndValidateErrorType = anyOf(is("custom_sql"), is("connection"), is("permissions"), is("data"));

export const isPostIntegrationsDirectCdiSourcesSourceIdPreviewAndValidateResult = objectOf({
  status: anyOf(is("valid"), is("invalid")),
  preview: maybe(isPreviewAndValidatePreview),
  errors: arrayOf(string),
  error_type: maybe(isPreviewAndValidateErrorType),
});
